import type { FC, PropsWithChildren } from 'react'
import { useRef } from 'react'
import { Box, spacing, type Sx, useIsMobileVariant } from '@dhl-ui/components'

export type WithFixedBottomComponentProps = {
  element?: React.ReactNode
  sx?: Sx
}

// TODO: make it work for both variants, one or more buttons
export const WithFixedBottomComponent: FC<PropsWithChildren<WithFixedBottomComponentProps>> = ({
  children,
  element,
  sx,
}: PropsWithChildren<WithFixedBottomComponentProps>) => {
  const ref = useRef<HTMLElement>(null)
  const isMobile = useIsMobileVariant()

  return (
    <Box>
      <Box sx={{ paddingBottom: `${ref.current?.clientHeight ?? 96}px` }}>{children}</Box>

      <Box
        sx={{
          ...sx,
          backgroundColor: 'background.paper',
          borderTop: ({ palette }) => `1px solid ${palette.grey[300]}`,
          margin: spacing(0, -2),
          padding: spacing(0, 2),
          zIndex: ({ zIndex }) => zIndex.appBar,
          ...(isMobile && {
            bottom: 0,
            left: spacing(2),
            right: spacing(2),
            position: 'fixed',
            p: 2,
          }),
        }}
        ref={ref}
      >
        {element}
      </Box>
    </Box>
  )
}
